module.exports = __webpack_public_path__ + "img/parter-work00.ba6f0128.png";